import { MCause } from './cause.model';
import { FiveWhys } from '../interfaces/treatment';

export class MFiveWhys{
    public whys: MCause[] = [];
    public selectedCause: number = null;
    public index: number = null;

    constructor(five: FiveWhys){
        five.causas.forEach(cause => {
            this.whys.push(new MCause({regular:cause}))
        });
        this.selectedCause = five.causa_escogida
    }
}